export const check = require('./check.svg');
export const play = require('./play.svg');
export const pa_green = require('./pa-green.svg');
export const bookmark = require('./bookmark.svg');
export const asset_error = require('./asset_error.svg');
export const copy = require('./copy.svg');
export const search = require('./search.svg');
export const filter = require('./filter.svg');
export const filter_black = require('./filter_black.svg');
export const sort = require('./sort.svg');
export const bottom_sheet = require('./bottom_sheet.svg');
export const asset_error2 = require('./asset_error2.svg');
export const ranking_podium = require('./ranking_podium.svg');
export const ba_crest = require('./ba_crest.svg');
export const info = require('./info.svg');
export const no_result = require('./no_result.svg');
export const offline = require('./offline.svg');
const step_1 = require('./1.svg');
const step_2 = require('./2.svg');
const step_3 = require('./3.svg');
export const confetti = require('./confetti.svg');
export const podiums = { step_1, step_2, step_3 };
export const ic_rabat = require('./ic_rabat.svg');
export const ic_score = require('./ic_score.svg');
export const coming_soon = require('./coming_soon.svg');



// WEBPACK FOOTER //
// ./src/assets/index.js